var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.654,
    height: 21.49,
    viewBox: "0 0 28.654 21.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-envelope",
    "data-name": "Icon awesome-envelope",
    d: "M28.111,11.6a.337.337,0,0,1,.543.263V23.3a2.687,2.687,0,0,1-2.686,2.686H2.686A2.687,2.687,0,0,1,0,23.3V11.865A.335.335,0,0,1,.543,11.6c1.254.974,2.916,2.211,8.624,6.358,1.181.862,3.173,2.675,5.16,2.664,2,.017,4.029-1.836,5.165-2.664C25.2,13.812,26.857,12.57,28.111,11.6ZM14.327,18.827c1.3.022,3.168-1.634,4.108-2.317,7.426-5.389,7.992-5.859,9.7-7.2a1.339,1.339,0,0,0,.515-1.058V7.186A2.687,2.687,0,0,0,25.967,4.5H2.686A2.687,2.687,0,0,0,0,7.186V8.25A1.347,1.347,0,0,0,.515,9.307c1.712,1.338,2.278,1.813,9.7,7.2C11.159,17.193,13.028,18.849,14.327,18.827Z",
    transform: "translate(0 -4.5)",
    fill: "#72efdb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/iconEnvelope.ab84e6279e79240028a0960ffc75b974.svg";
export { ForwardRef as ReactComponent };